import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

export interface Student {
  idStudent: number;
  idUserStudent: number;
  idGuardian: number;
  nameStudent: string;
  batchId: number;
  gradeId: number;
  idOrg: number;
  nameOrg: string;
  photo: string;
  arabicName?: string;
  birthDate?: string;
  birthPlace?: string;
  gender?: string;
  digiref?: number;
}

@Component({
  selector: 'app-children-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './children-selector.component.html',
  styleUrls: ['./children-selector.component.css'],
})
export class ChildrenSelectorComponent implements OnInit, OnChanges {
  @Input() autoSelectFirst: boolean = true;
  @Input() selectedStudentId: number | null = null;
  @Input() guardianId: number | null = null; // filtre par parent connecté
  @Output() selectedStudentIdChange = new EventEmitter<number | null>();
  @Output() studentSelected = new EventEmitter<Student>();
  @Output() studentsLoaded = new EventEmitter<Student[]>();

  students: Student[] = [];
  selectedStudent: Student | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    this.loadStudents();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedStudentId'] && this.students.length > 0) {
      this.syncSelectionWithId();
    }
  }

  private loadStudents() {
    if (isPlatformBrowser(this.platformId)) {
      const studentList = localStorage.getItem('studentList');
      if (studentList) {
        const all = JSON.parse(studentList) as Student[];

        // Détecter guardianId depuis localStorage si non fourni
        if (this.guardianId == null) {
          const userStr =
            localStorage.getItem('user') ||
            localStorage.getItem('connectedUser');
          if (userStr) {
            try {
              const user = JSON.parse(userStr);
              this.guardianId =
                user?.idGuardian ?? user?.id ?? user?.idUser ?? null;
            } catch {}
          }
        }

        // Filtrer par guardian si disponible
        this.students =
          this.guardianId != null
            ? all.filter((s) => (s as any).idGuardian === this.guardianId)
            : all;

        this.studentsLoaded.emit(this.students);

        if (this.selectedStudentId != null) this.syncSelectionWithId();
        else if (this.autoSelectFirst && this.students.length > 0)
          this.selectStudent(this.students[0]);
      }
    }
  }

  selectStudent(student: Student) {
    this.selectedStudent = student;
    console.log('student:', this.selectedStudent);
    this.studentSelected.emit(student);
    this.selectedStudentId = student.idStudent;

    console.log('Selected student ID:', this.selectedStudentId); // Debug log
    this.selectedStudentIdChange.emit(this.selectedStudentId);
  }

  private syncSelectionWithId() {
    const found = this.students.find(
      (s) => s.idStudent === this.selectedStudentId
    );
    if (found) {
      this.selectedStudent = found;
    }
  }
}
